/** Masks for Brazilian phone: 10 (landline) or 11 (mobile) digits. */
export function formatBrazilPhone(input: string, mask: string): string {
  const d = input.replace(/\D/g, "").slice(0, 11);
  if (d.length === 0) return "";

  const isMobileMask = mask.includes("99999");

  if (!isMobileMask) {
    const dd = d.slice(0, 10);
    if (dd.length <= 2) return `(${dd}`;
    if (dd.length <= 6) return `(${dd.slice(0, 2)}) ${dd.slice(2)}`;
    return `(${dd.slice(0, 2)}) ${dd.slice(2, 6)}-${dd.slice(6)}`;
  }

  const dd = d.slice(0, 11);
  if (dd.length <= 2) return `(${dd}`;
  if (dd.length <= 7) return `(${dd.slice(0, 2)}) ${dd.slice(2)}`;
  if (dd.length <= 10) {
    return `(${dd.slice(0, 2)}) ${dd.slice(2, 6)}-${dd.slice(6)}`;
  }
  return `(${dd.slice(0, 2)}) ${dd.slice(2, 7)}-${dd.slice(7)}`;
}

export function formatDateDMY(input: string): string {
  const d = input.replace(/\D/g, "").slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
}

export function formatCpfDisplay(input: string): string {
  const d = input.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) {
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  }
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

/** Resale code: one letter + up to 5 digits (mask a99999). */
export function formatResaleCode(input: string): string {
  const u = input.toUpperCase();
  let letter = "";
  const digitChars: string[] = [];
  for (const c of u) {
    if (/[A-Z]/.test(c) && letter.length === 0) {
      letter = c;
      continue;
    }
    if (/[0-9]/.test(c) && digitChars.length < 5) {
      digitChars.push(c);
    }
  }
  return letter + digitChars.join("");
}

/**
 * Applies display formatting for masks used in the app (no findDOMNode).
 */
export function formatMaskedValue(input: string, mask: string): string {
  if (mask === "(99) 99999-9999" || mask === "(99) 9999-9999") {
    return formatBrazilPhone(input, mask);
  }
  if (mask === "99/99/9999") {
    return formatDateDMY(input);
  }
  if (mask === "a99999" || mask === "A99999") {
    return formatResaleCode(input);
  }
  if (mask === "999.999.999-99") {
    return formatCpfDisplay(input);
  }
  return input;
}
